var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 34",
    style: {
      enableBackground: "new 0 0 29 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#BEE8FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "5.71,0.16 5.27,33.84 23.51,33.84 23.73,0.16  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.51,34H5.27c-0.04,0-0.08-0.02-0.11-0.05c-0.03-0.03-0.05-0.07-0.04-0.11L5.55,0.15C5.55,0.07,5.62,0,5.71,0h18.02 c0.04,0,0.08,0.02,0.11,0.05c0.03,0.03,0.05,0.07,0.05,0.11l-0.22,33.69C23.67,33.93,23.6,34,23.51,34z M5.43,33.69h17.93 l0.22-33.38H5.86L5.43,33.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5.75,
    className: "st1",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.57,10H8c-0.09,0-0.16-0.07-0.16-0.16V5.75c0-0.09,0.07-0.16,0.16-0.16h2.58c0.09,0,0.16,0.07,0.16,0.16v4.09 C10.73,9.93,10.66,10,10.57,10z M8.15,9.69h2.27V5.91H8.15V9.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.46,
    y: 5.75,
    className: "st1",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.04,10h-2.58c-0.09,0-0.16-0.07-0.16-0.16V5.75c0-0.09,0.07-0.16,0.16-0.16h2.58c0.09,0,0.16,0.07,0.16,0.16v4.09 C16.2,9.93,16.13,10,16.04,10z M13.62,9.69h2.26V5.91h-2.26V9.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.82,
    y: 14.78,
    className: "st1",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,19.03H7.82c-0.09,0-0.16-0.07-0.16-0.16v-4.09c0-0.09,0.07-0.16,0.16-0.16h2.58c0.09,0,0.16,0.07,0.16,0.16v4.09 C10.55,18.96,10.48,19.03,10.4,19.03z M7.97,18.72h2.26v-3.78H7.97V18.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.29,
    y: 14.78,
    className: "st1",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.86,19.03h-2.58c-0.09,0-0.16-0.07-0.16-0.16v-4.09c0-0.09,0.07-0.16,0.16-0.16h2.58c0.09,0,0.16,0.07,0.16,0.16v4.09 C16.02,18.96,15.95,19.03,15.86,19.03z M13.44,18.72h2.26v-3.78h-2.26V18.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.82,
    y: 23.81,
    className: "st1",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,28.06H7.82c-0.09,0-0.16-0.07-0.16-0.16v-4.09c0-0.09,0.07-0.16,0.16-0.16h2.58c0.09,0,0.16,0.07,0.16,0.16v4.09 C10.55,27.99,10.48,28.06,10.4,28.06z M7.97,27.74h2.26v-3.78H7.97V27.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.29,
    y: 23.81,
    className: "st1",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.86,28.06h-2.58c-0.09,0-0.16-0.07-0.16-0.16v-4.09c0-0.09,0.07-0.16,0.16-0.16h2.58c0.09,0,0.16,0.07,0.16,0.16v4.09 C16.02,27.99,15.95,28.06,15.86,28.06z M13.44,27.74h2.26v-3.78h-2.26V27.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.6,
    y: 5.75,
    className: "st1",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.18,10H18.6c-0.09,0-0.16-0.07-0.16-0.16V5.75c0-0.09,0.07-0.16,0.16-0.16h2.58c0.09,0,0.16,0.07,0.16,0.16v4.09 C21.34,9.93,21.27,10,21.18,10z M18.76,9.69h2.26V5.91h-2.26V9.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.43,
    y: 14.78,
    className: "st1",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,19.03h-2.58c-0.09,0-0.16-0.07-0.16-0.16v-4.09c0-0.09,0.07-0.16,0.16-0.16H21c0.09,0,0.16,0.07,0.16,0.16v4.09 C21.16,18.96,21.09,19.03,21,19.03z M18.58,18.72h2.26v-3.78h-2.26V18.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.43,
    y: 23.81,
    className: "st1",
    width: 2.58,
    height: 4.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,28.06h-2.58c-0.09,0-0.16-0.07-0.16-0.16v-4.09c0-0.09,0.07-0.16,0.16-0.16H21c0.09,0,0.16,0.07,0.16,0.16v4.09 C21.16,27.99,21.09,28.06,21,28.06z M18.58,27.74h2.26v-3.78h-2.26V27.74z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding01);
export default __webpack_public_path__ + "static/media/Building-01.f8d3bd2005b6546d64ab5a599b7099ac.svg";
export { ForwardRef as ReactComponent };